import Axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import constants from "../../constants/constants.json";
import Message from "../../helper/Message";
import { Button, Checkbox, DatePicker, Modal, Select, Table } from "antd";
import moment from "moment";
import Highlighter from "react-highlight-words";
import Search from "./Search/Search";
import { SearchOutlined } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { plansAPI } from "../../apis/planApi";

export default function Users(props) {
  const plans = useSelector((state) => state.userReducer.plans);
  // const planMe = useSelector(state => state.useReducer.plan)
  const [plan, setPlan] = useState(false);
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [open, setOpen] = useState(false);
  const [expireTime, setExpireTime] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(false);

  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <Search
        setSearchText={setSearchText}
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
        close={close}
        searchInput={searchInput}
        handleSearch={handleSearch}
        handleReset={handleReset}
        dataIndex={dataIndex}
        setSearchedColumn={setSearchedColumn}
      />
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "",
      name: "checkbox",
      dataIndex: "checkbox",
      key: "checkbox",
      render: (status, record) => {
        return (
          <Checkbox
            value={record.checkbox}
            onChange={(e) => {
              const checked = e.target.checked;
              // Update the checkbox value in the data
              const newData = users.map((item) =>
                item.userId === record.userId
                  ? { ...item, checkbox: checked }
                  : item
              );
              // Update the state with the new data

              setUsers(newData);
            }}
          />
        );
      },
    },
    {
      title: "name",
      name: "name",
      dataIndex: "userName",
      key: "userName",
      ...getColumnSearchProps("userName"),
    },
    {
      title: "email",
      name: "email",
      dataIndex: "userMail",
      key: "userMail",
      ...getColumnSearchProps("userMail"),
    },
    {
      title: "roleName",
      name: "roleName",
      dataIndex: "roleName",
      key: "roleName",
      ...getColumnSearchProps("roleName"),
    },
    {
      title: "createTime",
      name: "createTime",
      dataIndex: "userCreateTime",
      key: "userCreateTime",
      ...getColumnSearchProps("userCreateTime"),
      render: (status, record) => {
        return (
          <spann>
            {moment(record.userCreateTime, "X").format("YYYY-MM-DD")}
          </spann>
        );
      },
    },
    {
      title: "planName",
      name: "planName",
      dataIndex: "planName",
      key: "planName",
      ...getColumnSearchProps("planName"),
    },
    {
      title: "ExpireTime",
      name: "ExpireTime",
      dataIndex: "invoiceExpireTime",
      key: "invoiceExpireTime",
      ...getColumnSearchProps("invoiceExpireTime"),
      render: (status, record) => {
        return (
          <span>
            {moment(record.invoiceExpireTime, "X").format(
              "YYYY-MM-DD hh:mm:ss"
            )}
          </span>
        );
      },
    },
  ];

  const fetchUsers = async () => {
    try {
      setLoading(true);
      if (!plans) {
        plansAPI(dispatch);
      }
      const res = await Axios.get(constants.url + "/admin/users", {
        headers: {
          authorization: "Bearer " + localStorage.getItem("pnsToken"),
        },
      });
      const resPlans = await plansAPI(dispatch);
      if (res.data.status === 202) {
        setUsers(
          res.data.result.users.map((user) => {
            return { ...user, checkbox: false };
          })
        );
      } else {
        Message.warning(res.data.result.message);
      }
      setLoading(false);
    } catch (error) {
      Message.error("Communication error");
      setLoading(false);
    }
  };

  const activePlan = async () => {
    try {
      const usersId = users
        .filter((x) => x.checkbox === true)
        .map((user) => {
          if (user.checkbox) {
            return user.userId;
          }
        });
      if (usersId.length === 0) {
        Message.warning("select users");
      }
      const res = await Axios.put(
        constants.url + "/admin/upgradePlan",
        {
          usersId: usersId,
          expireTime: expireTime,
          planStatus: plan,
        },
        {
          headers: {
            authorization: "Bearer " + localStorage.getItem("pnsToken"),
          },
        }
      );

      if (res.data.status === 202) {
        Message.success("their plans updated successfully ");
        setOpen(false);
        setExpireTime(false);
        setPlan(false);
      } else {
        Message.warning(res.data.result.message);
      }
    } catch (error) {
      Message.error("Communication error");
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await Axios.get(constants.url + "/admin/roles", {
        headers: {
          authorization: "Bearer " + localStorage.getItem("pnsToken"),
        },
      });
      if (res.data.status === 202) {
        setRoles(res.data.result.roles);
      } else {
        Message.warning(res.data.result.message);
      }
    } catch (error) {
      Message.error("Communication error");
    }
  };

  const changeUserRole = async () => {
    try {
      const res = await Axios.put(
        constants.url + "/admin/user/role",
        {
          users: users.filter((u) => u.checkbox === true),
          roleId: selectedRole,
        },
        {
          headers: {
            authorization: "Bearer " + localStorage.getItem("pnsToken"),
          },
        }
      );
      if (res.data.status === 202) {
        Message.success(res.data.result.message);
        setOpen(false)
        fetchUsers()
      } else {
        Message.warning(res.data.result.message);
      }
    } catch (error) {
      Message.error("Communication error");
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        style={{ marginBottom: 5 }}
        type="primary"
      >
        active custom plan
      </Button>
      <Button
        onClick={() => setOpen("role")}
        style={{ marginBottom: 5, marginLeft: 20 }}
        type="primary"
      >
        change role
      </Button>
      <Table
        loading={loading}
        dataSource={users}
        columns={columns}
        pagination={false}
      />
      <Modal
        closable={true}
        onCancel={() => {
          setOpen(false);
          setPlan(false);
        }}
        onOk={() => (open === "role" ? changeUserRole() : activePlan())}
        open={open}
      >
        {open === "role" ? (
          <div>
            <Select
              placeholder="change user's role"
              onChange={(value) => setSelectedRole(value)}
              style={{ width: "200px" }}
            >
              {roles.map((item, i) => {
                return (
                  <Select.Option key={item.roleId} value={item.roleId}>
                    {item.roleName}
                  </Select.Option>
                );
              })}
            </Select>
            <br />
            <br />

            <h2>List of users to change role</h2>
            {users
              .filter((e) => e.checkbox === true)
              .map((item, i) => (
                <h3 key={i}>{item.userName}</h3>
              ))}
          </div>
        ) : (
          <div>
            select a plan :{" "}
            <Select
              placeholder="Select a plan"
              value={plan}
              onChange={(value) => {
                setPlan(value);
              }}
              style={{ width: "200px" }}
            >
              {plans &&
                plans.map((plan) => (
                  <Select.Option value={plan.status} key={plan.status}>
                    {plan.name}
                  </Select.Option>
                ))}
            </Select>
            <DatePicker
              disabledDate={(date) => date.format("X") < moment().format("X")}
              renderExtraFooter={() => "extra footer"}
              onChange={(e, date) => {
                setExpireTime(e.unix());
              }}
              style={{ marginTop: 5 }}
              showTime
            />
          </div>
        )}
      </Modal>
    </>
  );
}
